import React from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaChevronDown } from "react-icons/fa";
import axiosInstance from '../../axiosInstance';
import "../../styles/MultiSelectFilter.css";
import MultiSelectFilter from "../../CommonMultiSelectFilter/MultiSelectFilter";

const JobsFilter = ({
    showFilters,
    setShowFilters,
    activeTab,
    selectedProject,
    setSelectedProject,
    selectedJobNumber,
    setSelectedJobNumber,
    selectedJobType,
    setSelectedJobType,
    selectedDate,
    setselectedDate,
    selectedStatus,
    setSelectedStatus,
    fromDate,
    toDate,
    setFromDate,
    selectedDivision,
    setSelectedDivision,
    setToDate,
    selectedVendor,
    setSelectedVendor,
    vendorInputValue,
    setVendorInputValue,
    setMenuOpen,
    loadProjectOptions,
    setOpenByArrow,
    loadJobOptions,
    loadJobTypes,
    loadVendorOptions,
    handleClearFilters,
    handleApply,
    setIsClearing,
    selectedProfitCenter,
    setSelectedProfitCenter,
    selectedCity,
    setSelectedCity,
    selectedState,
    setSelectedState,
    selectedZone,
    setSelectedZone,
    plantCode,
    setPlantCode
}) => {

    const zoneOptions = [
        { label: "East", value: "east" },
        { label: "West", value: "west" },
        { label: "South", value: "south" },
        { label: "North", value: "north" }
    ];

    const loadProfitCenterOptions = async (inputValue) => {
        try {
            const res = await axiosInstance.get(
                "/projects/get_profit_centre",
                { params: { term: inputValue || '' } }
            );

            return (res.data?.autosuggestion || []).map(p => ({
                label: p.label,
                value: p.value
            }));
        } catch (error) {
            console.error(error);
            return [];
        }
    };

    const loadPlantCodeOptions = async (inputValue) => {
        try {
            const res = await axiosInstance.get(
                "/plant_code/autosuggestion",
                { params: { term: inputValue || '' } }
            );

            return (res.data?.autosuggestion || []).map(p => ({
                label: p.label,
                value: p.value
            }));
        } catch (error) {
            console.error(error);
            return [];
        }
    };


    const loadCityOptions = async (inputValue) => {
        try {
            const res = await axiosInstance.get("/get_city", {
                params: { term: inputValue || "" }
            });

            return (res.data?.suggestionlist || []).map(p => ({
                label: p.label,
                value: p.value
            }));
        } catch (error) {
            console.error(error);
            return [];
        }
    };

    const loadStateOptions = async (inputValue) => {
        try {
            const res = await axiosInstance.get("/get_state", {
                params: { term: inputValue || "" }
            });

            return (res.data?.suggestionlist || []).map(p => ({
                label: p.label,
                value: p.value
            }));
        } catch (error) {
            console.error(error);
            return [];
        }
    };

    const customSelectStyles = {
        control: (base, state) => ({
            ...base,
            minHeight: "40px",
            borderRadius: "12px",
            fontSize: "13px",
            width: "100%",
            borderColor: state.isFocused ? "#454CF2" : "#D0D6DF",
            boxShadow: state.isFocused ? "0 0 0 1px #454CF2" : "none",
            "&:hover": { borderColor: "#454CF2" },
        }),
        container: (base) => ({ ...base, width: "100%" }),
        menu: (base) => ({ ...base, fontSize: "12px" }),
        menuList: (base) => ({
            ...base,
            maxHeight: "250px",
            overflowY: "auto"
        }),
        multiValue: (base) => ({
            ...base,
            backgroundColor: '#F0F4F8',
            borderRadius: '4px',
            padding: '2px 6px',
            margin: '2px',
            maxWidth: '120px',
        }),
        multiValueLabel: (base) => ({
            ...base,
            color: '#19324C',
            fontSize: '12px',
            fontWeight: 500
        }),
        valueContainer: (base) => ({
            ...base,
            maxHeight: "35px",
            height: "40px",
            overflowY: "auto",
            overflowX: "hidden",
            flexWrap: "wrap",
            alignItems: "center",
            paddingTop: "4px",
            paddingBottom: "4px",
        }),
        multiValueRemove: (base) => ({
            ...base,
            color: '#19324C',
            ':hover': {
                backgroundColor: 'transparent',
                color: '#ff0000'
            }
        })
    };

    return (
        <>
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
            >
                <p className="filter-header">Filter</p>
                {/* <div
                    onClick={() => setShowFilters(!showFilters)}
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                        cursor: "pointer",
                        color: "#454CF2",
                        fontWeight: 600,
                        fontSize: "14px",
                        fontFamily: "'Work Sans', sans-serif",
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            backgroundColor: "#EDF3F9",
                            borderRadius: "50%",
                            width: "24px",
                            height: "24px",
                            boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                            transition: "transform 0.3s ease",
                            transform: showFilters ? "rotate(180deg)" : "rotate(0deg)",
                        }}
                    >
                        <FaChevronDown
                            style={{
                                color: "#454CF2",
                                fontSize: "14px",
                                display: "block",
                                lineHeight: 1,
                            }}
                        />
                    </div>
                </div> */}
            </div>

            {/* Conditionally render filters */}
            {showFilters && (
                <>
                    <div className="filter-all" style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr",
                        gap: "12px",
                        // marginTop: "5px"
                    }}>
                        {/* Project - MultiSelectFilter */}
                        <MultiSelectFilter
                            label="Project"
                            value={selectedProject || []}
                            onChange={(selected) => {
                                setSelectedProject(selected);
                                if (!selected || selected.length === 0) {
                                    setIsClearing(true);
                                }
                            }}
                            loadOptions={loadProjectOptions}
                            placeholder="Search project..."
                            styles={customSelectStyles}
                        />

                        {/* Plant Code - New Field */}
                        <MultiSelectFilter
                            label="Plant Code"
                            value={plantCode || []}
                            onChange={(selected) => {
                                setPlantCode(selected);
                                if (!selected || selected.length === 0) {
                                    setIsClearing(true);
                                }
                            }}
                            loadOptions={loadPlantCodeOptions}
                            placeholder="Select Plant Code"
                            styles={customSelectStyles}
                        />

                        {/* Job Number - MultiSelectFilter */}
                        <MultiSelectFilter
                            label="Job Number"
                            value={selectedJobNumber || []}
                            onChange={(selected) => {
                                setSelectedJobNumber(selected);
                                if (!selected || selected.length === 0) {
                                    setIsClearing(true);
                                }
                            }}
                            loadOptions={loadJobOptions}
                            placeholder="Select Job Number"
                            styles={customSelectStyles}
                        />

                        {/* Job Type - MultiSelectFilter */}
                        <MultiSelectFilter
                            label="Job Type"
                            value={selectedJobType || []}
                            onChange={(selected) => {
                                setSelectedJobType(selected);
                                if (!selected || selected.length === 0) {
                                    setIsClearing(true);
                                }
                            }}
                            loadOptions={loadJobTypes}
                            placeholder="Select Job Type"
                            styles={customSelectStyles}
                        />

                        {(activeTab === "sales" || activeTab === "cost") && (
                            <div className="filter-field">
                                <p className="filter-text">Date Range</p>
                                <div style={{ width: "100%" }}>
                                    <DatePicker
                                        selectsRange
                                        startDate={fromDate}
                                        endDate={toDate}
                                        onChange={(update) => {
                                            const [start, end] = update;
                                            setFromDate(start);
                                            setToDate(end);

                                            if (!start && !end) {
                                                setIsClearing(true);
                                            }
                                        }}
                                        isClearable
                                        placeholderText="Select date range"
                                        className="filter-date-range-input"
                                    />
                                </div>
                            </div>
                        )}

                        {(activeTab !== "sales" && activeTab !== "cost") && (
                            <>
                                <div className="filter-field">
                                    <p className="filter-text">Job Created Date</p>
                                    <input
                                        type="date"
                                        className="filter-dropdown"
                                        value={selectedDate}
                                        onChange={(e) => setselectedDate(e.target.value)}
                                    />
                                </div>

                                {activeTab.toLowerCase() === "submitted" && (
                                    <div className="filter-field">
                                        <p className="filter-text">Status</p>
                                        <select
                                            className="select-filter-dropdown"
                                            value={selectedStatus}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                setSelectedStatus(value);

                                                if (!value) {
                                                    setIsClearing(true);
                                                }
                                            }}
                                        >
                                            <option value="">Select</option>
                                            <option value="submitted">Submitted</option>
                                            <option value="partially invoiced">
                                                Partially Invoiced
                                            </option>
                                            <option value="completed">Completed</option>
                                        </select>
                                    </div>
                                )}
                            </>
                        )}
                        {["draft", "sales"].includes(activeTab.toLowerCase()) && (
                            <div className="filter-field">
                                <p className="filter-text">Job Type Division</p>
                                <select
                                    className="select-filter-dropdown"
                                    value={selectedDivision || ''}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setSelectedDivision(value);

                                        if (!value) {
                                            setIsClearing(true);
                                        }
                                    }}
                                >
                                    <option value="">Select</option>
                                    <option value="scs">SCS</option>
                                    <option value="ff">FF</option>
                                </select>
                            </div>
                        )}

                        {/* Vendor - MultiSelectFilter (only for cost tab) */}
                        {activeTab === "cost" && (
                            <MultiSelectFilter
                                label="Vendor"
                                value={selectedVendor || []}
                                onChange={(selected) => {
                                    setSelectedVendor(selected);
                                    if (!selected || selected.length === 0) {
                                        setIsClearing(true);
                                    }
                                }}
                                loadOptions={loadVendorOptions}
                                placeholder="Select Vendor..."
                                styles={customSelectStyles}
                            />
                        )}

                        {/* Profit Center - MultiSelectFilter */}
                        <MultiSelectFilter
                            label="Profit Center"
                            value={selectedProfitCenter || []}
                            onChange={(selected) => {
                                setSelectedProfitCenter(selected);
                                if (!selected || selected.length === 0) {
                                    setIsClearing(true);
                                }
                            }}
                            loadOptions={loadProfitCenterOptions}
                            placeholder="Select Profit Center"
                            styles={customSelectStyles}
                        />

                        {/* City - MultiSelectFilter */}
                        <MultiSelectFilter
                            label="City"
                            value={selectedCity || []}
                            onChange={(selected) => {
                                setSelectedCity(selected);
                                if (!selected || selected.length === 0) {
                                    setIsClearing(true);
                                }
                            }}
                            loadOptions={loadCityOptions}
                            placeholder="Select City"
                            styles={customSelectStyles}
                        />

                        {/* State - MultiSelectFilter */}
                        <MultiSelectFilter
                            label="State"
                            value={selectedState || []}
                            onChange={(selected) => {
                                setSelectedState(selected);
                                if (!selected || selected.length === 0) {
                                    setIsClearing(true);
                                }
                            }}
                            loadOptions={loadStateOptions}
                            placeholder="Select State"
                            styles={customSelectStyles}
                        />

                        {/* Zone - MultiSelectFilter */}
                        <MultiSelectFilter
                            label="Zones"
                            value={selectedZone || []}
                            onChange={(selected) => {
                                setSelectedZone(selected);
                                if (!selected || selected.length === 0) {
                                    setIsClearing(true);
                                }
                            }}
                            options={zoneOptions}
                            isAsync={false}
                            placeholder="Select Zone"
                            styles={customSelectStyles}
                        />


                        {(activeTab === "submitted" || activeTab === "cost") && (
                            <div className="filter-field">

                                <p className="filter-text">Job Type Division</p>
                                <select
                                    className="select-filter-dropdown"
                                    value={selectedDivision || ''}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setSelectedDivision(value);

                                        if (!value) {
                                            setIsClearing(true);
                                        }
                                    }}
                                >
                                    <option value="">Select</option>
                                    <option value="scs">SCS</option>
                                    <option value="ff">FF</option>
                                </select>
                            </div>
                        )}

                        {["draft", "sales"].includes(activeTab.toLowerCase()) && (
                            <>
                                <div className="filter-field"></div>
                                <div className="filter-field"></div>
                                <div className="filter-field"></div>
                                <div className="filter-field"></div>
                            </>
                        )}

                        {/* {(activeTab === "draft" || activeTab === "sales" || activeTab !== "submitted" && activeTab !== "cost") && (
                            <div className="filter-field button-grid">
                                <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end", marginTop: "22px" }}>
                                    <button className="jobs-cancel-btn" onClick={handleClearFilters}>
                                        Reset
                                    </button>
                                    <button className="jobs-apply-btn" onClick={handleApply}>
                                        Apply
                                    </button>
                                </div>
                            </div>
                        )} */}

                        {(activeTab !== "draft" && activeTab !== "sales" || activeTab === "submitted" && activeTab === "cost") && (
                            <>
                                <div className="filter-field"></div>
                                <div className="filter-field"></div>
                                <div className="filter-field"></div>
                                <div className="filter-field button-grid">
                                    <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end", marginTop: "22px" }}>
                                        <button className="jobs-cancel-btn" onClick={handleClearFilters}>
                                            Reset
                                        </button>
                                        <button className="jobs-apply-btn" onClick={handleApply}>
                                            Apply
                                        </button>
                                    </div>
                                </div>
                            </>
                        )}


                    </div>

                    {(activeTab === "draft" || activeTab === "sales") && (
                        <div
                            style={{
                                display: "flex",
                                gap: "10px",
                                justifyContent: "flex-end",
                            }}
                        >
                            <button className="jobs-cancel-btn" onClick={handleClearFilters}>
                                Reset
                            </button>
                            <button className="jobs-apply-btn" onClick={handleApply}>
                                Apply
                            </button>
                        </div>
                    )}
                </>
            )}
        </>
    );
};

export default JobsFilter
